import { Creators as AlertActions } from '../../../appRedux/ducks/alert'
import store from '../../../appRedux/store'
import { api, getErrorRequestMessage, request } from '../../../util/handlerRequestUtil'

/**
 * Lista os grupos de alternativos do agricultor garantindo que o retorno seja sempre um array.
 * O DataTable (PrimeReact) faz `value.map`, então qualquer outro tipo derruba a tela inteira.
 * Resposta fora do contrato vira [] e, quando `skipError` é false, dispara o alerta padrão.
 */
export async function listCustomerGroups(customerId, skipError = false) {
  const groups = await request(api.listCustomerGroupByCustomerId(customerId), false, skipError)

  if (Array.isArray(groups)) return groups

  if (!skipError) {
    store.dispatch(AlertActions.openAlert(getErrorRequestMessage()))
  }

  return []
}
